var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"db-ChromeMainContent"},[_c('left-nav',{attrs:{"leftNavItems":_vm.leftNavItems,"title":"Configurations"}}),_c('configuration-detail',{attrs:{"selectedNavItem":_vm.selectedNavItem}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }